<template>
  <div class="relative mr-5">
    <span
      class="align-middle cursor-pointer leading-none"
      @click="toggleMenu()"
    >
      <span class="text-sm font-medium">
        <strong>Selected region: </strong>
        <span
          class="bg-gray-100 py-2 px-4 ml-2 rounded-full hover:bg-gray-200 transition-all"
          >{{ findCurrentRegion()?.name }} ({{ findCurrentRegion()?.id }})</span
        >
      </span>
    </span>
    <div
      v-if="menu"
      v-click-away="toggleMenu"
      class="fixed z-20 top-header right-0 text-right"
    >
      <div class="bg-nucleus-white shadow-lg">
        <div
          v-for="(region, index) in regions"
          :key="index"
          class="p-5 opacity-50 hover:bg-gray-50 hover:opacity-100 cursor-pointer transition-all"
          :class="{ 'opacity-100': currentRegion === region.id }"
          @click="changeRegion(region.id)"
        >
          <span class="text-sm"> {{ region.name }} ({{ region.id }}) </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import Regions from "@/store/data/regions.json";
import { findRegion } from "@/utils/regions";

@Options({
  data() {
    return {
      menu: false,
      regions: Regions,
    };
  },
  computed: {
    currentRegion(): string {
      return this.$store.getters.getRegion;
    },
  },
  methods: {
    toggleMenu() {
      this.menu = !this.menu;
    },
    changeRegion(regionId: string) {
      this.$store.dispatch("changeRegion", regionId);
      this.menu = false;
    },
    findCurrentRegion() {
      return findRegion(this.currentRegion);
    },
  },
})
export default class RegionMenu extends Vue {}
</script>
